/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const powerElectricalSystemsEnumsPotentialConsequenceOptionEnum = {
    SLARisk: 'SLARisk',
    RedundancyLoss: 'RedundancyLoss',
    Outage: 'Outage',
    Other: 'Other',
} as const;

export type PowerElectricalSystemsEnumsPotentialConsequenceOptionEnumKey =
    (typeof powerElectricalSystemsEnumsPotentialConsequenceOptionEnum)[keyof typeof powerElectricalSystemsEnumsPotentialConsequenceOptionEnum];

export type PowerElectricalSystemsEnumsPotentialConsequenceOption =
    PowerElectricalSystemsEnumsPotentialConsequenceOptionEnumKey;
